import { ContentTopBar } from 'components';

export const LegalTopBar = () => {
  return (
    <>
      <ContentTopBar title={'Legal Documents'} />
    </>
  );
};
